/**
 * PremiumMultiple
 * 
 * @Author: Focci
 * @Date: 2024-10-25 16:07:19
 * @Last Modified by: Focci
 * @Last Modified time: 2024-10-25 16:07:19
 */

'use client'

// import PropTypes from 'prop-types'
import Carousel from '@comp/swiper/Carousel'
import useApp from '@hook/useApp'
import PromoteAgentCard from '@comp/page/property/promote-agents/PromoteAgentCard'
import PhoneButton from '@comp/page/property/agent-card/PhoneButton'
import useProgressRouter from '@hook/useProgressRouter'
import { detail } from '@lib/route/agent'
import { useLocale } from 'next-intl'
import { Waypoint } from 'react-waypoint'
import { useCallback, useMemo, useRef, useState } from 'react'
import { PremiumAgentListing } from './PremiumAgentCarouselListings'
import { getPremiumListings } from './_'
import PremiumEnquiry from './PremiumEnquiry'

function PremiumMultipleItem({ data, index }) {
  const enquiryDialog = useRef()
  
  if(index === 0) {
    return (
      <>
        <PromoteAgentCard
          data={{ ...data, list_stat: null }}
          onEstimateFreeButtonClick={() => enquiryDialog.current?.openDialog?.()}
          actions={
            <PhoneButton
              agentId={data?.id}
              phone={data?.phone_number}
              trackParams={{ agencyOfficeId: data?.office_id }} 
            />
          }
        />
        <PremiumEnquiry 
          ref={enquiryDialog} 
          house={data?.house} 
          agentId={data.id} 
          type="agent"
          displayAddressOfAppraisal
        />
      </>
    )
  }
  
  return (
    <PremiumAgentListing data={data} />
  )
}

export default function PremiumMultiple({ house, slidesPerView = 3, ...props }) {
  const { isMobile } = useApp()
  const locale = useLocale()
  const { routerPush } = useProgressRouter()
  
  const [enter, setEnter] = useState(false)
  const { agent, properties: listings, sold_properties: solds } = house || {}
  const data = useMemo(() => [
    { ...agent, house: listings?.[0] }, 
    ...getPremiumListings(listings, solds)
  ], [agent, listings, solds])

  const handleSlideNextTransitionEnd = useCallback((e) => {
    if(agent?.slug && (e.isEnd || e.snapIndex >= 5)) {
      routerPush(detail(agent.slug), locale)
    }
  }, [agent?.slug, locale, routerPush])
  
  return (
    <Waypoint onEnter={() => setEnter(true)}>
      <div className="p-2 md:p-4 bg-cf0 min-h-[336px]">
        {enter && <Carousel
          showNavigation={false}
          slidesPerView={isMobile ? 'auto' : slidesPerView}
          paginationWrapperClassName="bottom-0 md:-bottom-2"
          spaceBetween={15}
          breakpoints={{}}
          data={data}
          SlideRender={PremiumMultipleItem}
          onSlideNextTransitionEnd={handleSlideNextTransitionEnd}
          {...props}
        />}
      </div>
    </Waypoint>
  )
}

// PremiumMultiple.propTypes = {
//   className: PropTypes.string,
// }
